"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultContext = {
    id: undefined,
    labelId: undefined,
    messageId: undefined,
    invalid: false,
    required: false,
    isGroup: false,
};
var FieldContext = react_1.createContext(defaultContext);
var useFieldContext = function () { return react_1.useContext(FieldContext); };
exports.useFieldContext = useFieldContext;
exports.default = FieldContext;
